import { useEffect } from "react";
import { PaymentPayload, Section, usePaymentStatusManager } from "@lookiero/payments-front";

interface UsePaymentInstrumentEventsFunctionArgs {
  readonly onSuccess: (payload: PaymentPayload) => void;
  readonly onError: (payload: PaymentPayload) => void;
}

interface UsePaymentInstrumentEventsFunction {
  (args: UsePaymentInstrumentEventsFunctionArgs): void;
}

const usePaymentInstrumentEvents: UsePaymentInstrumentEventsFunction = ({ onSuccess, onError }) => {
  const refreshStatus = usePaymentStatusManager(Section.BOX_CHECKOUT);

  useEffect(() => {
    const { isLoading, consumePayload } = refreshStatus;

    if (isLoading) {
      return;
    }

    consumePayload((payload) => {
      if (payload.success) {
        onSuccess(payload);
      } else {
        onError(payload);
      }
    });
  }, [onError, onSuccess, refreshStatus]);
};

export { usePaymentInstrumentEvents };
